import { render, staticRenderFns } from "./inventoryBinDialog.vue?vue&type=template&id=67b84f30&"
import script from "./inventoryBinDialog.vue?vue&type=script&lang=js&"
export * from "./inventoryBinDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports